// ═══════════════════════════════════════════════════════════════════════════
// clavesRollup — el espejo de front de `functions/dashboardRollups/claves.js`
// ═══════════════════════════════════════════════════════════════════════════
//
// POR QUÉ EXISTE (report xBxPGtK6rrOsuuhBGkrB). La clave `${empresaId}__${dominio}`
// de `dashboardRollups` estaba escrita a mano en ~18 lugares. Del lado del front
// eran seis: el hook lector genérico y cinco componentes que la armaban inline.
//
// ⚠️ ES UNA COPIA, Y ESO ESTÁ DECLARADO. El front no puede importar de
// `functions/`, así que la definición vive dos veces. Lo que la hace segura es
// que `functions/dashboardRollups/claves.test.js` carga ESTE archivo y verifica
// que las dos produzcan exactamente lo mismo: si alguien cambia una y no la
// otra, se pone rojo. Mismo molde que `src/core/lib/syncEndpointsCatalog.test.js`,
// que ya hace esa comparación para el catálogo de endpoints.
//
// Dos copias con un test de paridad no son lo mismo que 18 sin nada: cuando el
// report irEHPI9c27aokZeEIOxs pida particionar los rollups por canal, hay que
// tocar dos lugares y el test avisa si falta uno.
//
// CANAL obligatorio (mismo cambio que el backend, mismo motivo: ver
// `functions/dashboardRollups/claves.js`). Sin canal, throw.
// ═══════════════════════════════════════════════════════════════════════════

const SEPARADOR = '__'
const CANAL_ML = 'mercado-libre'

/**
 * El docId de `dashboardRollups`.
 *
 * @param {string} empresaId
 * @param {string} dominio  'publicidad' | 'publicaciones' | 'catalogo' | 'posicion' | …
 * @param {string} canal    'mercado-libre' | 'tienda-nube' | … — obligatorio.
 * @returns {string}
 */
export function claveRollup(empresaId, dominio, canal) {
  if (!canal) throw new Error('claveRollup: falta canal — no hay clave sin canal declarado')
  return canal === CANAL_ML
    ? `${empresaId}${SEPARADOR}${dominio}`
    : `${empresaId}${SEPARADOR}${canal}${SEPARADOR}${dominio}`
}

export { SEPARADOR, CANAL_ML }
